export const TENANT_PANASONIC_URI = "panasonic"
export const TENANT_FLIPKART_URI = "smarthomeplus"
export const TENANT_AMAZON_URI = "appliancehub"